export default __webpack_public_path__ + "static/media/wallpaper_bg3.02e3ec85.png";